<template>
    <section id="Menu_Strip">
        <section class="position-absolute w-100 d-none d-md-flex justify-content-center">
            <span v-if="organizations?.length > 1" class="px-2 text-white account-name" @click="changeOrganization">
                {{ organizationName }} <i class="fas fa-caret-down ms-1"></i>
            </span>
            <span v-else class="px-2 text-white account-name"> {{ organizationName }} </span>
        </section>
        <section class="ms-auto d-flex z-2">
            <a class="btn text-white strip-item d-flex" v-if="isConnectEnabled">
                <MessagesPreview :is-axxess-planner-header="isAxxessPlannerHeader"></MessagesPreview>
                <span class="d-none d-md-inline ms-1" @click="navigateToAxxessChat()">Axxess Connect</span>
            </a>
            <a class="btn text-white strip-item" @click="navigateToAxxessCentral()">
                <i class="far fa-calendar-check menu-text"></i><span class="d-none d-md-inline">Axxess Planner</span>
            </a>
            <span class="px-2 text-white strip-item dropdown app-menu">
                <a
                    class="text-white dropdown-toggle"
                    href="javascript:void(0);"
                    id="User_Dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <i class="far fa-user-circle menu-text"></i><span class="d-none d-md-inline">My Account</span>
                </a>
                <div class="dropdown-menu dropdown-menu-end mt-0" aria-labelledby="User_Dropdown">
                    <a class="dropdown-item" href="javascript:void(0);" @click="redirectToProfile()">
                        <i class="fas fa-user me-1"></i> Profile
                    </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="javascript:void(0);" @click="logout()">
                        <i class="fas fa-sign-out-alt me-1"></i>Log Out
                    </a>
                </div>
            </span>
        </section>
    </section>
    <nav class="navbar navbar-expand-lg border border-gray p-0" id="App_Navbar">
        <!-- Logo -->
        <a class="navbar-brand d-flex flex-column justify-content-center" id="Brand_Logo">
            <!-- INFO: Logo is added as a background to avoid a Chrome rendering issue -->
            <span class="logo"></span>
        </a>
        <!-- Small screen - burger icon menu -->
        <button
            class="navbar-toggler text-white"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#App_Menu"
            aria-controls="App_Menu"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <i class="fas fa-bars me-2"></i>
        </button>
        <!-- App Menu-->
        <div class="collapse navbar-collapse" id="App_Menu">
            <ul class="navbar-nav me-auto h-lg-100" id="App__MainMenu">
                <li
                    v-for="route in displayRoutes"
                    :key="route"
                    :class="`nav-item ${isActivePath(route.path) ? 'active' : ''} dropdown app-menu`"
                >
                    <!-- MENU ICON AND NAME -->
                    <!-- INFO: data-bs-toggle="dropdown" is not used to avoid default click behavior -->
                    <a
                        class="nav-link dropdown-toggle h-100 d-none d-lg-inline-block"
                        href="javascript:void(0);"
                        v-if="route.children"
                        v-on:mouseover="closeNotifications()"
                        :id="`MainMenu__${route.name}`"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <i :class="route.meta.iconClass" aria-hidden="true"></i>
                        <span class="ps-1" v-if="!isSearchExpanded">{{ route.meta.menuName }}</span>
                    </a>
                    <a
                        class="nav-link dropdown-toggle d-lg-none"
                        data-bs-toggle="dropdown"
                        href="javascript:void(0);"
                        v-if="route.children"
                        :id="`MainMenu__${route.name}`"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <i :class="route.meta.iconClass"></i>
                        <span class="ps-1" v-if="!isSearchExpanded">{{ route.meta.menuName }}</span>
                    </a>
                    <a
                        class="nav-link"
                        :href="route.href"
                        v-if="!route.children"
                        data-bs-toggle="collapse"
                        data-bs-target="#App_Menu"
                    >
                        <i :class="route.meta.iconClass"></i>
                        <span class="ps-1" v-if="!isSearchExpanded">{{ route.meta.menuName }}</span>
                    </a>
                    <!-- SUB-MENU -->
                    <div class="dropdown-menu" :aria-labelledby="`MainMenu__${route.name}`">
                        <div v-for="subRoute of route.children" :key="subRoute" class="p-0 m-0">
                            <a
                                v-show="showRoute(subRoute.meta.navItem) && subRoute.meta?.showInLevelTwoNav !== false"
                                :class="`dropdown-item ${isActivePath(route.path) ? 'active' : ''}`"
                                :data-bs-toggle="`${subRoute.meta && subRoute.path ? '' : 'collapse'}`"
                                data-bs-target="#App_Menu"
                                :rel="`${subRoute.meta && subRoute.path ? 'noopener noreferrer' : ''}`"
                                @click="goToRoute(subRoute.path)"
                            >
                                <span>{{ subRoute.meta.menuName }}</span>
                            </a>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown app-menu">
                    <a
                        class="nav-link dropdown-toggle d-none d-lg-inline-block"
                        href="javascript:void(0);"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <i class="fas fa-life-ring"></i>
                        <span class="ps-1" v-if="!isSearchExpanded">Help</span>
                    </a>
                    <a
                        class="nav-link dropdown-toggle d-lg-none"
                        data-bs-toggle="dropdown"
                        href="javascript:void(0);"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <i class="fas fa-life-ring"></i>
                        <span class="ps-1" v-if="!isSearchExpanded">Help</span>
                    </a>
                    <!-- SUB-MENU -->
                    <div class="dropdown-menu">
                        <a
                            class="dropdown-item"
                            href="https://community.axxessweb.com/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            <span>User Community</span>
                        </a>
                        <a
                            class="dropdown-item"
                            href="https://www.axxess.com/help/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            <span>Help Center</span>
                        </a>
                        <a class="dropdown-item" @click="displayLiveLoginToken()" v-if="liveLoginData">
                            <span>Support Key</span>
                        </a>
                    </div>
                </li>
            </ul>
            <!-- Right Nav -->
            <ul class="navbar-nav" id="App__MenuRight">
                <li>
                    <a
                        v-if="showEmployeeSearch"
                        class="nav-link"
                        :class="showEmployees ? 'selected' : ''"
                        @click="toggleEmployeesMenus()"
                        v-tooltip="{ title: employeesTooltip, placement: 'bottom' }"
                    >
                        <i class="icon fa fa-search"></i>
                        <span class="text-center ps-1">Employees</span>
                    </a>
                </li>
                <li>
                    <a
                        class="nav-link"
                        :class="showPatients ? 'selected' : ''"
                        @click="togglePatientsMenu()"
                        v-tooltip="{ title: patientsTooltip, placement: 'bottom' }"
                    >
                        <i class="icon fa fa-search"></i>
                        <span class="text-center ps-1">Patients</span>
                    </a>
                </li>
            </ul>
            <!-- Left Nav -->
        </div>
    </nav>
</template>

<script lang="ts" src="./CentralNav.ts"></script>
<style src="./CentralNav.scss"></style>
